






















import { Component, Vue, Prop } from "vue-property-decorator";
import { Appointment } from "../api";
import dateFlipWithTime from "shared/filters/dateFlipWithTime";
import hoursToTime from "shared/filters/hoursToTime";
import NoteDialog from "./NoteDialog.vue";

@Component({
  filters: { dateFlipWithTime, hoursToTime },
  components: { NoteDialog },
})
export default class SubscriptionsTable extends Vue {
  @Prop({ required: true })
  appointments!: Appointment[];

  headers = [
    {
      text: this.t("project_description"),
      value: "project_description",
      sortable: false,
    },
    {
      text: this.t("task_description"),
      value: "task_description",
      sortable: false,
    },
    { text: this.t("plan_date"), value: "plan_date", sortable: false },
    { text: this.t("duration"), value: "duration", sortable: false },
    { text: this.t("executors"), value: "executors", sortable: false },
    { text: "", value: "note", sortable: false },
  ];

  pagination = {
    rowsPerPage: 5,
    sortBy: "plan_date",
  };

  rowsPerPageItems = [
    5,
    15,
    25,
    { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
  ];

  private t(key: string): string {
    return this.$t("appointments.table." + key).toString();
  }
}
